




























































































import  {Component, Prop, Vue} from 'vue-property-decorator';
import {User} from '@/oauth/User';
import {UserDto} from '@/oauth/UserDto';
import {Validation} from '@/utils/Validation';
import {AuthTokenDto, CodeResp} from '@/oauth/AuthTokenDto';
import {getModule} from 'vuex-module-decorators';
import {AuthStore} from '@/oauth/AuthStore';
import CodeSlider from '@/components/CodeSlider.vue';
import { CustomerStore } from '@/store/CustomerStore';
import {CustomerDto} from "@/dto/CustomerDto";
import {AuthorityDto} from "@/oauth/AuthorityDto";

@Component({
  components: {CodeSlider},
})
export default class RegisterDriver extends Vue {
  @Prop({default: () => new User()}) private user!: User;
  private loading = false;
  private Validation = Validation;
  TIME_COUNT = 60;
  show = true;
  timer = 0;
  count = 0;
  codeResp: CodeResp = new CodeResp();
  nameList: string[] = [];

  async handleSubmit() {
    if (this.codeResp.sessionId.length > 0) {
      await this.postUser();
      const cs = getModule(CustomerStore);
      cs.setCurrentCustomer(await CustomerDto.findById(125));
      const role = cs.currentCustomer.toRole();
      const authority = await AuthorityDto.findByAuthority(role);
      const user = await UserDto.findByUsername(this.user.username)
      user.addAuthority(authority);
      await UserDto.save(user);
    } else {
      this.$q.notify('请完成滑块验证');
    }
  }

  match() {
    if (this.user.password == this.user.secondpassword) {
      return true;
    } else return "请保证两次密码相同！";
  }

  async nameNotExist(i: string) {
    const b = await UserDto.findByUsername1(this.user.username);
    if (b) {
      return "用户已存在";
    }
    return true;
  }


  private async verification() {
    this.count = this.TIME_COUNT;
    this.show = !this.show;
    this.timer = window.setInterval(() => {
      if (this.count > 0 && this.count <= this.TIME_COUNT) {
        this.count--;
      } else {
        this.show = true;
        clearInterval(this.timer);
        this.timer = 0;
      }
    }, 1000)
    this.user.receiver = this.user.username;
    const b = await UserDto.findByUsername1(this.user.username);
    if (b) {
      this.$q.notify('用户已存在发不了验证码');
      this.show = true;
    } else await AuthTokenDto.registerSend(this.user.receiver);
    if (this.user.username == '') {
      this.$q.notify('请输入手机号')
      this.show = true  ;
    }
  }


  async postUser() {

    const nf = this.$q.notify({type: 'ongoing', message: '正在处理...', timeout: 0});
    try {
      this.loading = true;
      // eslint-disable-next-line no-undef,@typescript-eslint/ban-ts-ignore
      // @ts-ignore
      window.NoCaptcha.reset();
      const authToken = await AuthTokenDto.getTokenByRegister(this.user, this.codeResp);
      AuthTokenDto.save(authToken);
      await getModule(AuthStore).updateLoginUser();
      // await this.$router.push({name: 'registerSuccess'});
      this.$q.notify({message: '成功'});
      this.$root.$emit('UserAdded');
      // await this.$router.push({name: 'KeShangSelect'});
      nf({type: 'positive', message: '完成', timeout: 1500});
      await this.$router.push({name: 'registerDriverSuccess'});
      this.loading = false;
      // await this.$router.push({name: 'success'});
    } catch (e) {
      this.loading = false;
      nf({type: 'negative', message: '错:' + e, timeout: 2500});
      // await this.$router.push({name: 'register'});
    }
  }

  private mounted() {
    return;
  }
}


